import * as React from 'react';
import type { Invoice } from 'contracts/tracking-v2/invoices';
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableHeader,
} from 'components/ui/table';
import { Formatter } from 'utils/Formatter';
import { cn } from 'lib/utils'

type Props = React.ComponentProps<'div'> & {
  invoices: Invoice[];
}

export const InvoicesTable = ({ invoices, className, ...props }: Props) => {
  return (
    <div {...props} className={cn('max-h-[calc(100vh-480px)] overflow-y-auto', className)}>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>NF</TableHead>
            <TableHead>Emissão</TableHead>
            <TableHead>Origem</TableHead>
            <TableHead>Destino</TableHead>
            <TableHead>Transportadora</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoices.map(row => (
            <TableRow key={row.id}>
              <TableCell>{row.id}</TableCell>
              <TableCell>{[row.infnfeIdeNnf, row.infnfeIdeSerie].join('-')}</TableCell>
              <TableCell>{Formatter.date(row.infnfeIdeDhemi)}</TableCell>
              <TableCell>{[row.originCity?.name, row.originCity?.uf].filter(Boolean).join('/')}</TableCell>
              <TableCell>{[row.destinationCity?.name, row.destinationCity?.uf].filter(Boolean).join('/')}</TableCell>
              <TableCell>{row?.carrier?.tradeName || '---'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};